import type { WipRecordI } from 'declarations/interfaces/wip';

export interface WipChirpTicketToolbarStateI {
  disabled: boolean;
  tooltip: string;
}

/**
 * Returns the disabled state + tooltip text for the "Create Chirp" toolbar button on the WIP
 * page. Mirrors WarrQueue's WIP toolbar contract: at least one row must be selected before the
 * dealer can launch the create-ticket flow.
 */
export const getWipChirpTicketToolbarState = (
  wipItemsSelected: readonly WipRecordI[]
): WipChirpTicketToolbarStateI => {
  const selectedCount = wipItemsSelected.length;
  if (selectedCount === 0) {
    return {
      disabled: true,
      tooltip: 'Select at least one row to create a Chirp ticket',
    };
  }
  if (selectedCount === 1) {
    return {
      disabled: false,
      tooltip: 'Create Chirp ticket',
    };
  }
  return {
    disabled: false,
    tooltip: 'Create Chirp tickets',
  };
};
